'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function FoodLogHeader() {
  const [visionOpen, setVisionOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="text-forge-label mb-1">Food Log · THEO</div>
          <h1 className="text-2xl font-black tracking-wide text-foreground">Monday, 08 June 2026</h1>
          <p className="text-xs text-muted-foreground mt-0.5">Log it before you negotiate with it.</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setVisionOpen(true)}
            className="flex items-center gap-2 px-3 py-2 rounded-md border border-accent/40 text-accent bg-accent/10 hover:bg-accent/20 transition-all text-sm font-bold tracking-wider"
          >
            <Icon name="CameraIcon" size={16} />
            FORGE VISION
          </button>
          <button className="btn-forge-primary px-4 py-2 rounded-md text-sm flex items-center gap-2">
            <Icon name="PlusIcon" size={16} />
            ADD FOOD
          </button>
        </div>
      </div>
      {/* Forge Vision Modal */}
      {visionOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
          <div className="card-elevated border border-border rounded-xl p-6 w-full max-w-md mx-4 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="text-forge-label mb-0.5">AI Food Recognition</div>
                <div className="text-lg font-black text-foreground">FORGE VISION</div>
              </div>
              <button
                onClick={() => setVisionOpen(false)}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                <Icon name="XMarkIcon" size={20} />
              </button>
            </div>

            <div className="border-2 border-dashed border-border rounded-lg p-8 text-center mb-4 hover:border-primary/40 transition-colors cursor-pointer">
              <Icon name="CameraIcon" size={32} className="text-muted-foreground mx-auto mb-3" />
              <p className="text-sm text-muted-foreground mb-1">Take a photo or upload an image</p>
              <p className="text-2xs text-muted-foreground">AI will estimate foods, portions and macros</p>
            </div>

            <div className="grid grid-cols-2 gap-3 mb-4">
              <button className="btn-forge-primary py-2.5 rounded-md text-sm flex items-center justify-center gap-2">
                <Icon name="CameraIcon" size={16} />
                TAKE PHOTO
              </button>
              <button className="btn-forge-ghost py-2.5 rounded-md text-sm flex items-center justify-center gap-2">
                <Icon name="ArrowUpTrayIcon" size={16} />
                UPLOAD
              </button>
            </div>

            {/* Mock AI result */}
            <div className="card-forge rounded-lg p-4 border border-primary/20">
              <div className="text-forge-label mb-3">AI ESTIMATE — REVIEW BEFORE SAVING</div>
              <div className="space-y-2 mb-4">
                {[
                  { food: 'Grilled Chicken Breast', grams: 180, cal: 297, protein: 56, carbs: 0, fat: 6 },
                  { food: 'Brown Rice (cooked)', grams: 150, cal: 165, protein: 3, carbs: 35, fat: 1 },
                  { food: 'Broccoli', grams: 80, cal: 27, protein: 2, carbs: 5, fat: 0 },
                ]?.map((item) => (
                  <div key={`vision-${item?.food}`} className="flex items-center justify-between text-xs">
                    <div>
                      <div className="font-medium text-foreground">{item?.food}</div>
                      <div className="text-muted-foreground">{item?.grams}g · {item?.cal} kcal</div>
                    </div>
                    <div className="text-right text-muted-foreground">
                      <div>P: {item?.protein}g</div>
                      <div>C: {item?.carbs}g · F: {item?.fat}g</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex items-center justify-between mb-3">
                <div className="text-2xs text-muted-foreground">Confidence Score</div>
                <div className="flex items-center gap-2">
                  <div className="w-24 macro-bar-track">
                    <div className="h-full rounded-full bg-primary" style={{ width: '82%' }} />
                  </div>
                  <span className="text-xs font-bold text-primary font-tabular">82%</span>
                </div>
              </div>
              <p className="text-2xs text-amber-400 mb-3">
                ⚠ AI estimates only. Review and adjust portions before saving.
              </p>
              <div className="grid grid-cols-2 gap-2">
                <button className="btn-forge-primary py-2 rounded text-xs">APPROVE & LOG</button>
                <button
                  onClick={() => setVisionOpen(false)}
                  className="btn-forge-ghost py-2 rounded text-xs"
                >
                  DISCARD
                </button>
              </div>
            </div>
            {/* BACKEND: POST /api/ai/vision — send image, receive structured JSON food estimates */}
          </div>
        </div>
      )}
    </>
  );
}